import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { Switch } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

export function Safety() {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('form.security service')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <Switch
            labelI18n='form.driver needs security check'
            name='isDriverNeedsSentToSecurity'
            readOnly
          />
        </Grid>
        <Grid xs={6}>
          <Switch
            labelI18n='form.driver sent to security'
            name='isDriverWasSentToSecurity'
            readOnly
          />
        </Grid>
      </Grid>
    </Container>
  )
}
